import { gql } from "@apollo/client"

const GET_TIMETABLE_CHANGES = gql`
  query($input: SessionTimetableChangesInput!) {
    sessionTimetableChanges(input: $input) {
      id
      last_updated_at
      slots {
        id
        starts_at
        ends_at
        status
        booking {
          id
          student_initials
          booking_slot_id
          student_id
        }
      }
    }
  }
`

export { GET_TIMETABLE_CHANGES }